import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { RoleBuilder } from '../../models/builders/role.builder';
import { Privilege } from '../../models/privilege';
import { Role } from '../../models/role';
import { getErrorHandlingOptions } from '../base/headers';
import { RoleUserActivity } from './../../models/role-user-activity';
import { mapCollection } from './../../utils/collection.utils';

const createBody = (roleUserActivity: RoleUserActivity) => ({
  hash: roleUserActivity.hash,
  userActivity: roleUserActivity.userActivity
});
const createPrivilegeBody = (privilege: Privilege) => ({
  hash: privilege.hash
});

// tslint:disable-next-line: no-console
const roleBody = (role: Role) => (
  {
    hash: role.code,
    name: role.name,
    operational: role.operational,
    imagePath: role.imagePath,
    roleUserActivities: mapCollection(createBody, role.roleUserActivities),
    privileges: mapCollection(createPrivilegeBody, role.privileges)
  });

@Injectable()
export class RoleApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}roles`;
  }

  getRoles() {
    return this.httpClient.get(`${this.apiUrl}`, getErrorHandlingOptions())
      .pipe(
        map(RoleBuilder.fromList)
      );
  }

  getOperationalRoles() {
    return this.httpClient.get(`${this.apiUrl}/operational`, getErrorHandlingOptions())
      .pipe(
        map(RoleBuilder.fromList)
      );
  }

  getRole(hash: string) {
    return this.httpClient.get(`${this.apiUrl}/${hash}`)
      .pipe(
        map(RoleBuilder.fromJson)
      );
  }

  createRole(role) {
    return this.httpClient.post(this.apiUrl, roleBody(role)).pipe(map(RoleBuilder.fromJson));
  }

  updateRole(role: Role) {
    const body = roleBody(role);
    return this.httpClient.put(`${this.apiUrl}/${role.code}`, body);
  }

  deleteRole(role: Role) {
    return this.httpClient.delete(`${this.apiUrl}/${role.code}`);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/role-api.service.ts